import { ButtonProps } from "@chakra-ui/react";

import { colors } from "src/colors";

export type IconButtonVariantType =
  | "primary"
  | "secondary"
  | "roundedPrimary"
  | "roundedSecondary"
  | "outlined";

type Props = ButtonProps & {
  iconActiveColor?: string;
  iconDisabledColor?: string;
};

export const ICON_BUTTONS_THEMES: { [key in IconButtonVariantType]: Props } = {
  primary: {
    iconActiveColor: colors.white.off,
    iconDisabledColor: colors.grey[500],

    sx: {
      path: {
        fill: colors.orange[400]
      }
    },

    _hover: {
      bg: colors.grey[200]
    },

    _active: {
      bg: colors.orange[400],
      path: {
        fill: colors.white.off
      }
    },

    _disabled: {
      bg: "transparent",
      _active: { bg: "transparent" },
      _hover: { bg: "transparent" }
    }
  },

  secondary: {
    iconActiveColor: colors.black[900],
    iconDisabledColor: colors.grey[500],

    sx: {
      path: {
        fill: colors.black[900]
      }
    },

    _hover: {
      bg: colors.grey[200]
    },

    _active: {
      bg: colors.grey[300]
    },

    _disabled: {
      bg: "transparent",
      _active: { bg: "transparent" },
      _hover: { bg: "transparent" }
    }
  },

  roundedPrimary: {
    iconDisabledColor: colors.grey[500],
    borderRadius: "50%",

    sx: {
      path: {
        fill: colors.black[900]
      }
    },

    _hover: {
      bg: colors.grey[200]
    },

    _active: {
      bg: colors.grey[400]
    }
  },

  roundedSecondary: {
    iconDisabledColor: colors.grey[500],
    borderRadius: "50%",
    bg: colors.black[900],

    sx: {
      path: {
        fill: colors.white.off
      }
    },

    _hover: {
      bg: colors.black[800]
    },

    _active: {
      bg: colors.black[600]
    },

    _disabled: {
      bg: colors.grey[700],
      _hover: {
        bg: colors.grey[700]
      }
    }
  },

  outlined: {
    iconActiveColor: colors.white.off,
    iconDisabledColor: colors.grey[500],
    border: `1px solid ${colors.grey[400]}`,

    sx: {
      path: {
        fill: colors.black[900]
      }
    },

    _hover: {
      bg: colors.grey[200],
      "border-color": colors.grey[200]
    },

    _active: {
      bg: colors.grey[400],
      "border-color": colors.grey[400]
    },

    _disabled: {
      bg: "transparent",
      "border-color": "transparent",
      _active: { bg: "transparent" },
      _hover: { bg: "transparent", "border-color": "transparent" }
    }
  }
};
